export const defaultRentPercent = 0.02;

export const fivePercentSavingsTarget = 5;

export const defaultDownPaymentAmount = 5000;

export const defaultHomePrice = 250000;

export const TWO_PERCENT_DECIMAL = 0.02;
